enum BoardItemListType {
  Planned = '00000000-0000-0000-0000-000000000001',
  InProgress = '00000000-0000-0000-0000-000000000002',
  Done = '00000000-0000-0000-0000-000000000003',
  Information = '00000000-0000-0000-0000-000000000010',
}

export default BoardItemListType;
